import React from 'react';
import { ValidationScope } from '@/components/forms/validation';
import { useValidationManager } from '@/utils/hooks';
import { ExternalAgreementParticipantCreateOptions } from '@/services/external-agreements';
import ChangeRequestParticipantSelectList from '@/seller/components/change-requests/ChangeRequestParticipantSelectList';
import Banner from '@/components/Banner';
import { Trans } from '@lingui/react/macro';
import InfoIconWithTooltip from '@/seller/components/InfoIconWithTooltip';
import theme from './ExternalAgreementApproveWizard.module.scss';

interface ExternalAgreementApproveWizardParticipantsProps {
    projectId: number;
    value: ExternalAgreementParticipantCreateOptions[];
    onChange(data: ExternalAgreementParticipantCreateOptions[]): void;
}

const ExternalAgreementApproveWizardParticipants: React.FC<ExternalAgreementApproveWizardParticipantsProps> = ({
    projectId,
    value,
    onChange,
}) => {
    const validationManager = useValidationManager();

    return (
        <ValidationScope validationManager={validationManager}>
            <div className={theme.smallHeader}>
                <Trans>Participants</Trans>
                <InfoIconWithTooltip
                    color="light"
                    title={<Trans>Participants</Trans>}
                    content={
                        <Trans>
                            <strong>Please note</strong>, it is not possible to remove the person who uploaded the external
                            agreement.
                        </Trans>
                    }
                />
            </div>

            <ChangeRequestParticipantSelectList
                onChange={(newValue) => onChange(newValue)}
                projectId={projectId}
                value={value}
            />
            {value.length > 1 && (
                <Banner type="info">
                    <Trans>
                        <strong>Please note</strong>, additional participants will result with an open change request - even
                        if this agreement is already signed by the buyer. This means that quotes from those users are needed
                        in order to price and deliver the contents of this agreement.
                    </Trans>
                </Banner>
            )}
        </ValidationScope>
    );
};

export default ExternalAgreementApproveWizardParticipants;